import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Account from '../../../containers/Account/Account';

// import IntegrationsBase from './IntegrationsBase';
import NetworkBase from './NetworkBase';
import ProfileBase from './ProfileBase';

const AccountBase = () => (
  <Routes>
    <Route>
      <Route exact path="/profile/*" element={<ProfileBase />} />
      <Route exact path="/network/*" element={<NetworkBase />} />
      <Route exact path="/settings" element={<Account tab="settings" />} />
      <Route exact path="/notifications" element={<Account tab="notifications" />} />
    </Route>
  </Routes>
);

export default AccountBase;
